import React from 'react';
import { Skeleton } from '../../../components/shared/Skeleton/Skeleton';
import './shared-modules.css';

// Esqueleto de las pantallas por bloques (recepción, inventario...) mientras cargan sus datos
export const ScreenSkeleton = ({ blocks = 4 }: { blocks?: number }) => (
  <div className="module-screen-grid">
    {Array.from({ length: blocks }).map((_, i) => (
      <div key={i} className="module-panel module-screen-block">
        <Skeleton width="40%" height="12px" />
        <div className="module-screen-fields">
          {Array.from({ length: 4 }).map((__, j) => (
            <div key={j} className="skeleton-block">
              <Skeleton width="50%" height="9px" />
              <Skeleton width="100%" height="30px" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
